// extracted by mini-css-extract-plugin
module.exports = {"howItWorksSection":"HowItWorksSection_howItWorksSection__XdEiT","container":"HowItWorksSection_container__HpN6N","formWrapper":"HowItWorksSection_formWrapper__76vt6"};